//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";
import { Feedback } from "@/utils/notify-toaster.js";
import BackendServices from "@/services/backend-services.js";

export default {
  name: "UserProfile",
  props: ["validState"],
  components: {},
  mounted: function () {
    BackendServices.getDepartments().then((response) => {
      this.departmentList = response.data;
    });
  },
  computed: {
    checkPassword() {
      return this.newPassword == this.newPasswordConfirmation;
    },
  },
  data: () => ({
    validForm: false,
    name: "",
    surname: "",
    email: "",
    roleName: "",
    department_id: "",
    userFunction: "",
    password: "",
    newPassword: "",
    newPasswordConfirmation: "",
    departmentList: [],
    showPasswordField: true,
    loading: false,
    isPwd1: true,
    isPwd2: true,
    isPwd3: true,
    particlesStatus: false,
  }),
  methods: {
    required,
    noValidation,
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    async submitUserData() {
      let sendObject = {
        user: {
          id: this.id,
          email: this.email,
          name: this.name,
          surname: this.surname,
          department_id: this.department_id,
          userFunction: this.userFunction,
        },
      };
      try {
        await BackendServices.saveUserSettings(sendObject);
        Feedback.success("Informações Atualizadas");
      } catch (error) {
        Feedback.error(error.message);
      }
    },
    async getUserInfo() {
      this.loading = true;
      let result = await BackendServices.getUserSettings();
      this.name = result.data[0].name;
      this.surname = result.data[0].surname;
      this.department_id = result.data[0].department_id;
      this.id = result.data[0].id;
      this.roleName = result.data[0].role;
      this.email = result.data[0].email;
      this.userFunction = result.data[0].user_function;
      this.loading = false;
    },
    async changePassword() {
      let sendObject = {
        id: this.id,
        new_password: this.newPassword,
        old_password: this.password,
      };
      if (this.checkPassword) {
        if (this.newPassword.length < 6) {
          Feedback.error("A password tem de ter pelo menos 6 caracteres");
          return;
        }
        try {
          await BackendServices.changePassword(sendObject);
          Feedback.success("Password alterada com sucesso");
        } catch (error) {
          Feedback.error(error.response.data.message);
        }
      } else {
        Feedback.error("As passwords não coincidem");
      }
    },
  },
  beforeMount() {
    this.getUserInfo();
    localStorage.getItem("particles") === "true"
      ? (this.particlesStatus = true)
      : (this.particlesStatus = false);
  },
  watch: {
    particlesStatus: function () {
      localStorage.setItem("particles", this.particlesStatus);
    },
  },
};
